import fetch from './fetch';
const isHandleError = true;
const urlMap = {
    queryQuestions: '/bot/question',
    queryHistory: '/bot/history',
    chat: '/bot/chat',
    resumeConfirm: '/bot/resume/confirm',
    upload: '/bot/upload',
    like: '/bot/answer/like',
};
// 获取推荐问题列表
export const queryQuestions = async (data) => {
    return fetch({
        url: urlMap.queryQuestions,
        // url: 'https://mocks.alibaba-inc.com/mock/%E5%8F%8C%E7%BB%87%E6%8E%A5%E5%8F%A3//bot/question',
        method: 'POST',
        data,
        loading: false,
        isHandleError
    });
};
// 获取历史记录
export const queryHistory = async (data) => {
    return fetch({
        url: urlMap.queryHistory,
        method: 'POST',
        data,
        loading: false,
        isHandleError
    });
};
// 聊天接口
export const chat = async (data) => {
    return fetch({
        url: urlMap.chat,
        method: 'POST',
        data,
        loading: false,
        isHandleError
    });
};
// 简历流程-确认
export const resumeConfirm = async (data) => {
    return fetch({
        url: urlMap.resumeConfirm,
        method: 'POST',
        data,
        loading: false,
        isHandleError
    });
};
// 上传接口
export const upload = async (data) => {
    return fetch({
        url: urlMap.upload,
        method: 'POST',
        data,
        loading: false,
        isHandleError
    });
};
// 点赞/点踩
export const like = async (data) => {
    return fetch({
        url: urlMap.like,
        method: 'POST',
        data,
        loading: false,
        isHandleError
    });
};
